<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>
<ion-content>
  <ion-toolbar class="ion-padding-top" mode="ios">
    <ion-searchbar
      placeholder="Search"
      (ionInput)="filterCountrylist($event)"
      (click)="modal.setCurrentBreakpoint(1)"
    ></ion-searchbar>
    <ion-progress-bar
      *ngIf="!countryCodes"
      type="indeterminate"
    ></ion-progress-bar>
  </ion-toolbar>
  <ion-list
    lines="none"
    *ngIf="countryCodes"
    class="ion-list-transparent-bg-color"
  >
    <ion-item
      (click)="selectCountryCode(item)"
      *ngFor="let item of countryCodes"
      class="ion-item-transparent-bg-color"
    >
      <ion-note slot="start" [innerHtml]="item.flag"> </ion-note>
      <ion-label>
        <h2 class="paragraph-primary-text-color">
          <span></span>
          {{ item.name }}
        </h2>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>
